import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import FreeApp from "../Sections/Download/FreeApp";

const TermsAndConditions = () => {
    const [sections, setSections] = useState([]);
    const [activeIndex, setActiveIndex] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // console.log("process.env.REACT_APP_BASE_URL::", process.env.REACT_APP_BASE_URL)

    // Get base URL from environment (supports both Vite and CRA)
    const baseUrl = import.meta.env?.VITE_BASE_URL || process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        const fetchPolicies = async () => {
            try {
                setLoading(true);
                const response = await fetch(
                    `${baseUrl}TermsAndCondition/Mobile/GetTermsAndConditionAsync`
                );
                const data = await response.json();

                // Transform API response into our sections array
                const normalizedSections = normalizeSections(data.result);
                setSections(normalizedSections);
                setActiveIndex(normalizedSections[0].id);
            } catch (err) {
                console.error("Failed to fetch policies:", err);
                setError("Unable to load legal information. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        if (baseUrl) {
            fetchPolicies();
        } else {
            setError("Base URL not configured. Please set VITE_BASE_URL in .env");
            setLoading(false);
        }
    }, [baseUrl]);

    // Handles various possible API response structures
    const normalizeSections = (apiData) => {
        // Case 1: API returns an array of sections directly
        if (Array.isArray(apiData)) {
            return apiData.map((item, idx) => ({
                id: idx,
                title: item.title || item.type || item?.typeName || `Section ${idx + 1}`,
                content: item.content || item.description || item.html || "",
            }));
        }
        // Case 2: API returns { terms: {...}, privacy: {...} }
        if (apiData.terms && apiData.privacy) {
            return [
                { id: 0, title: "Terms of Service", content: apiData.terms.content || apiData.terms },
                { id: 1, title: "Privacy Policy", content: apiData.privacy.content || apiData.privacy },
            ];
        }
        // Case 3: API returns a single object with both inside
        if (apiData.termsOfService && apiData.privacyPolicy) {
            return [
                { id: 0, title: "Terms of Service", content: apiData.termsOfService },
                { id: 1, title: "Privacy Policy", content: apiData.privacyPolicy },
            ];
        }
        // Case 4: Fallback – try to use the whole data as one section
        if (apiData && typeof apiData === "object") {
            const content = apiData.content || apiData.data || JSON.stringify(apiData);
            return [{ id: 0, title: "Legal Information", content }];
        }
        // Default fallback
        return [
            { id: 0, title: "Terms of Service", content: "Content not available." },
            { id: 1, title: "Privacy Policy", content: "Content not available." },
        ];
    };

    const toggleSection = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="loading-container" style={{ textAlign: "center", padding: "4rem" }}>
                    <div className="loader">Loading legal information...</div>
                </div>
                <Footer />
            </>
        );
    }

    if (error) {
        return (
            <>
                <Navbar />
                <div className="error-container" style={{ textAlign: "center", padding: "4rem", color: "red" }}>
                    <p>{error}</p>
                    <button onClick={() => window.location.reload()}>Retry</button>
                </div>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Navbar />
            <main className="terms-privacy-page" style={{ maxWidth: "1200px", margin: "0 auto", padding: "2rem 1rem" }}>
                <h1 style={{ textAlign: "center", marginBottom: "2rem" }}>Legal Information</h1>

                <div className="accordion">
                    {sections.map((section, idx) => (
                        <div key={section.id} className="accordion-item" style={{ marginBottom: "1rem", border: "1px solid #e2e8f0", borderRadius: "8px", overflow: "hidden" }}>
                            <button
                                className="accordion-header"
                                onClick={() => toggleSection(idx)}
                                style={{
                                    width: "100%",
                                    textAlign: "left",
                                    padding: "1rem 1.5rem",
                                    backgroundColor: activeIndex === idx ? "#f7fafc" : "#fff",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "1.2rem",
                                    fontWeight: "600",
                                    transition: "all 0.2s",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                {section.title}
                                <span style={{ fontSize: "1.5rem" }}>{activeIndex === idx ? "−" : "+"}</span>
                            </button>
                            {activeIndex === idx && (
                                <div className="accordion-content" style={{ padding: "1rem 1.5rem", borderTop: "1px solid #e2e8f0", backgroundColor: "#fff" }}>
                                    <div dangerouslySetInnerHTML={{ __html: section.content }} />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </main>
            <FreeApp />
            <Footer />
        </>
    );
};

export default TermsAndConditions;